import React from 'react';
import { useTranslation } from 'react-i18next';
import StateBlock from './StateBlock';

// Wraps the card grid and owns the loading / empty states so every
// admin list page renders them identically.
const CardGrid = ({ loading, isEmpty, emptyTitle, emptyText, skeletonCount = 6, children }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="ad-grid">
        {Array.from({ length: skeletonCount }, (_, i) => (
          <div key={i} className="ad-skeleton" />
        ))}
      </div>
    );
  }

  if (isEmpty) {
    return (
      <StateBlock
        icon="fa-folder-open"
        title={emptyTitle || t('common.noData')}
        text={emptyText}
      />
    );
  }

  return <div className="ad-grid">{children}</div>;
};

export default CardGrid;
